import { useState } from 'react';
export function useToggle(initialState = false) {
    const [state, setState] = useState(initialState);
    const toggleOn = () => setState(true);
    const toggleOff = () => setState(false);
    const toggle = () => setState((state) => !state);
    const input = [state, toggleOn, toggleOff, toggle, setState];
    return Object.assign(input, {
        state,
        toggleOn,
        toggleOff,
        toggle,
        setState,
    });
}
//# sourceMappingURL=useToggle.js.map